var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.trip)?_c('TspTripPlanningForm',{attrs:{"trip":_vm.trip}}):_c('NoTripContent')
}
var staticRenderFns = []

export { render, staticRenderFns }